import React from 'react';
import Marquee from 'react-fast-marquee';

export default function Brands() {
  // Create an array with brand images from 1 to 16
  const brandImages = Array.from({ length: 30 }, (_, i) => ({
    id: i + 1,
    src: `/brands/brand_${(i + 1).toString().padStart(2, '0')}.png`,
    alt: `Brand Partner ${i + 1}`
  }));

  return (
    <div className="py-16 ">
      <div className="container mx-auto mb-8">
        <h2 className="text-3xl font-bold text-center text-indigo-900 mb-8">Our Trusted Partners</h2>
      </div>
      
      <Marquee
        gradient={false}
        speed={100}
        pauseOnHover={true}
        className="py-4"
      >
        {brandImages.map((brand) => (
          <div key={brand.id} className="mx-6">
            <img 
              src={brand.src} 
              alt={brand.alt} 
              className="h-16 md:h-20 object-contain" 
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
